import { Form } from "antd"
import { Checkbox, Text } from "components/common"
import { t } from "i18next"

const RACheckbox = ({ form, fieldName, value, getAccountant }) => (
  <Form.Item name={fieldName} valuePropName="checked">
    <Checkbox
      value={value}
      onChange={e => {
        if (e?.target?.checked) getAccountant(null, true)
        form.setFieldsValue({ [fieldName]: e?.target?.checked })
      }}
    >
      <Text className="gray-900">{t("Cash Submitted by RA")}</Text>
    </Checkbox>
  </Form.Item>
)

export default RACheckbox
